// Client-side citation generators (BibTeX + RIS)

function year(paper) {
  return paper.published_at ? new Date(paper.published_at).getFullYear() : new Date().getFullYear();
}

function citeKey(paper) {
  const first = paper.authors?.[0]?.name || "anon";
  const last = first.trim().split(/\s+/).pop().toLowerCase().replace(/[^a-z]/g, "");
  return `${last}${year(paper)}`;
}

export function toBibTeX(paper) {
  const authors = (paper.authors || []).map((a) => a.name).join(" and ");
  const journal = paper.journal?.title || "";
  const fields = [
    ["author", authors],
    ["title", paper.title],
    ["journal", journal],
    ["year", String(year(paper))],
    ["volume", paper.volume ? String(paper.volume) : ""],
    ["number", paper.issue ? String(paper.issue) : ""],
    ["pages", paper.pages || ""],
    ["doi", paper.doi || ""],
  ].filter(([, v]) => v);
  const body = fields.map(([k, v]) => `  ${k} = {${v}}`).join(",\n");
  return `@article{${citeKey(paper)},\n${body}\n}`;
}

export function toRIS(paper) {
  const lines = ["TY  - JOUR"];
  (paper.authors || []).forEach((a) => lines.push(`AU  - ${a.name}`));
  lines.push(`TI  - ${paper.title}`);
  if (paper.journal?.title) lines.push(`JO  - ${paper.journal.title}`);
  lines.push(`PY  - ${year(paper)}`);
  if (paper.volume) lines.push(`VL  - ${paper.volume}`);
  if (paper.issue) lines.push(`IS  - ${paper.issue}`);
  if (paper.pages) lines.push(`SP  - ${paper.pages}`);
  if (paper.doi) lines.push(`DO  - ${paper.doi}`);
  (paper.keywords || []).forEach((k) => lines.push(`KW  - ${k}`));
  lines.push("ER  - ");
  return lines.join("\n");
}

export function downloadText(filename, text) {
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
